var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tasks),function(task,taskIndex){return _c('div',{key:taskIndex},[_c('task-item',{attrs:{"task":task}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }